import React, { useState,useEffect,useRef } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { ChangeMobileNumber,ChangeMobileFormat } from "../../components/common/Common";

import "../../css/style.css";

//비밀번호 찾기
const FindID = () => {
  const navigate = useNavigate();

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  const [varMemberInfo,setMemberInfo] = useState({});

  const refName = useRef();
  const refMobile = useRef();
  const refChildren = useRef();
  const refFind = useRef();

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    const newMemberInfo = {mem_name:"", mem_mobile:"",ch_name:""};
    setMemberInfo(newMemberInfo);
    setParentMenus({showMenu:false,gotoMain:1});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFindIDHandler = async() => {
    if (varMemberInfo.mem_mobile === "") {
      alert('휴대폰 번호를 먼저 입력하세요'); return false;  
    } else if (varMemberInfo.mem_name === "" ) {
      alert('이름을 먼저 입력하세요'); return false;      
    } else if (varMemberInfo.ch_name === "" ) {
      alert('자녀명을 먼저 입력하세요'); return false;     
    }
    const sendData = {mode:1,dataInfos:varMemberInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_find_id_pwd`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        const mem_id = datas.mem_id;
        localStorage.setItem("foundID", mem_id);
        navigate('/Parents/FoundIDOK');
      } else {
        alert(datas.message);
      }
    });
  }
  //입력값 처리
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === 'mem_mobile') {
      const svalue = ChangeMobileNumber(value);
      setMemberInfo({...varMemberInfo,[name]:svalue});
    } else {
      setMemberInfo({...varMemberInfo,[name]:value});
    }
  }
  //키보드
  const onKeyPressHandler = (e,ino) => {
    if (e.key === 'Enter') {
      if(ino === 0) {
        refMobile.current.focus();
      } else if(ino === 1) {
        refChildren.current.focus();
      } else {
        refFind.current.click();
      }
    }
  }

  return (
    <div className="vh-content member-wrap">
      <HeaderUserTitle varPageTitle={'아이디 찾기'} varBackString={'/Parents/Login'}/>
      <div className="vh-content-body">
        <div className="form-group ms25 mb25 mt25">
          <label className="form-label">학부모명</label>
          <div className="field-group">
            <input type="text" name="mem_name" ref={refName} value={varMemberInfo.mem_name||""} placeholder="이름을 입력해주세요." className="form-control" onKeyPress={e=>onKeyPressHandler(e,0)} onChange={onChangeInputHandler}/>
          </div>
        </div>
        <div className="form-group  ms25 mb25">
          <label className="form-label">연락처 (- 제외 입력)</label>
          <div className="field-group">
            <input type="text" name="mem_mobile" ref={refMobile} value={ChangeMobileFormat(varMemberInfo.mem_mobile)} placeholder="휴대폰 번호를 입력하세요." className="form-control" onKeyPress={e=>onKeyPressHandler(e,1)} onChange={onChangeInputHandler}/>
          </div>
        </div>
        <div className="form-group  ms25 mb25">
          <label className="form-label">자녀명</label>
          <div className="field-group">
            <input type="text" name="ch_name" ref={refChildren} value={varMemberInfo.ch_name||""} placeholder="자녀명을 입력해주세요." className="form-control" onKeyPress={e=>onKeyPressHandler(e,2)} onChange={onChangeInputHandler}/>
          </div>
        </div>
        <div className="form-contoller bt-btn">
          <Link to="/Parents/Login" className="form-contoller-btn btn-no">취소</Link>
          <button ref={refFind} className="form-contoller-btn btn-yes" onClick={onFindIDHandler}>아이디 찾기</button>
        </div>
      </div>	
    </div>	
  );
}
export default FindID;